import { Injectable } from "@angular/core";
import { SidebarItemModel } from "../../models/sidebarItem.model";
import {
    SIDEBAR_KEY_LOG_LIST,
    SIDEBAR_KEY_NURSERY_LIST, SIDEBAR_KEY_PROMOTION_LIST
} from "../properties/sidebar.property";
import {
    BACKOFFICE_PATH, BACKOFFICEMAIN_PATH, LIST_PATH, LOG_PATH, NURSERY_PATH, PROMOTION_PATH
} from "../properties/path.property";
import { Router } from "@angular/router";
import { GenericUtils } from "./generic.utils";
import { logData } from "../../helpers/generic/generic.helper";

@Injectable({
    providedIn: "root"
})
export class SidebarUtils {

    constructor(
        protected router: Router,
        protected genericUtils: GenericUtils) {}

    public getElements(): SidebarItemModel[] {
        const path = this.router.url;
        const items: SidebarItemModel[] = [];

        logData(path);
        items.push(new SidebarItemModel(
            SIDEBAR_KEY_NURSERY_LIST,
            "SIDEBAR_COMPONENT_ITEM_NURSERY_LIST",
            BACKOFFICE_PATH + "/" + BACKOFFICEMAIN_PATH + "/" + NURSERY_PATH + "/" + LIST_PATH,
            null,
            "fa-warehouse",
            null,
            this.genericUtils.isPath(path, NURSERY_PATH)
        ));

        items.push(new SidebarItemModel(
            SIDEBAR_KEY_PROMOTION_LIST,
            "SIDEBAR_COMPONENT_ITEM_PROMOTION_LIST",
            BACKOFFICE_PATH + "/" + BACKOFFICEMAIN_PATH + "/" + PROMOTION_PATH + "/" + LIST_PATH,
            null,
            "fa-percent",
            null,
            this.genericUtils.isPath(path, PROMOTION_PATH)
        ));

        items.push(new SidebarItemModel(
            SIDEBAR_KEY_LOG_LIST,
            "SIDEBAR_COMPONENT_ITEM_LOG_LIST",
            BACKOFFICE_PATH + "/" + BACKOFFICEMAIN_PATH + "/" + LOG_PATH,
            null,
            "fa-chart-line",
            null,
            this.genericUtils.isPath(path, LOG_PATH)
        ));

        return items;
    }
}
